module.exports = require('./browser/algorithms.json')



// WEBPACK FOOTER //
// ./~/browserify-sign/algos.js